import { render, staticRenderFns } from "./quotation_list.vue?vue&type=template&id=736041a6&scoped=true&"
import script from "./quotation_list.vue?vue&type=script&lang=js&"
export * from "./quotation_list.vue?vue&type=script&lang=js&"
import style0 from "./quotation_list.vue?vue&type=style&index=0&id=736041a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736041a6",
  null
  
)

export default component.exports